export default "__VITE_ASSET__COtMKezF__"